export const UPDATE_SUCCESS = 'Профиль обновлен';
export const UPDATE_ERROR = 'Не удалось обновить профиль';
